<template>
<div class="popupWrap">
  <div class="popup_inner">
    <span><a href="javascript:" @click="colseModal()" ><img src="/static/images/main/close_menu.png" alt=""></a></span>
    <h2>SDK 다운로드 상세보기</h2>

    <!-- 내용 -->
    <div class="pop_sdk">
      <table>
        <colgroup>
          <col width="20%">
          <col width="*">
        </colgroup>
        <tbody>
          <tr>
            <th>제목</th>
            <td v-text="item.title"></td>
          </tr>
          <tr>
            <th>릴리즈 소개</th>
            <td v-text="item.contents" class="textprewrap"></td>
          </tr>
          <tr>
            <th>Ver</th>
            <td v-text="item.version">0.2</td>
          </tr>
          <tr>
            <th>첨부파일</th>
            <td>
              <ul>
                <li v-for="fileItem in item.files" v-bind:key="fileItem.keyid" >
                <a :href="'/web/file/download/'+fileItem.keyid">
                <img src="/static/images/contents/icon_file.png" :alt="fileItem.orgFileName" :text="fileItem.orgFileName" :title="fileItem.orgFileName"  />
                {{ fileItem.orgFileName }}
                </a>
                </li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="btn_area taC">
      <a href="javascript:" @click="colseModal()" class="btn_blue">확인</a>
    </div>

  </div>
</div>
</template>
<script>

export default {
  data: function () {
    return {
      item: this.viewsdk
    }
  },
  props: [
    'viewsdk'
  ],
  methods: {
    colseModal () {
      this.$emit('close')
    }
  },
  created () {

  },
  computed: {
  }
}
</script>

<style scoped>
th, td {
  text-align: center;
}
.textprewrap {
    white-space: pre-wrap;
    display: block;
    height: 260px;
    overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/SDKView.vue